export function VideoPlayer(video) {
    var hls;
    function initPlayer(sourceUrl, thumbnailUrl, onAttachedCallback, onErrorCallback) {
        
        if (!video) {
            console.error('Video element is not provided');
            return;
        }        
        if (thumbnailUrl) {
            video.poster = thumbnailUrl;
        }
        if (Hls.isSupported()) {
            hls = new Hls();
            hls.loadSource(sourceUrl);
            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                if (onAttachedCallback) {
                    onAttachedCallback()
                }
            });
        }
        // hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
        // When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
        // This is using the built-in support of the plain video element, without using hls.js.
        else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = sourceUrl;
        }
        else {
            if (onErrorCallback) {
                return onErrorCallback();
            }
            console.error('hls vodeo doesn`t supported by your browser');
        }
    }
    function onVideoPlay(callback) {
        if (!video) {
            return;
        }
        video.addEventListener('play', (e) => {
            if (callback) {
                callback(e);
            }
        })
    }

    function detach() {
        hls.detachMedia();
    }

    return {
        init: initPlayer,
        onPlay: onVideoPlay,
        detach
    }
}



//////////////////
// WEBPACK FOOTER
// ./scripts/static/video-player.js
// module id = 915
// module chunks = 0